import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { PortalOrdersBoard } from '@api/BoardSDK';
import { withBoardAuth } from '@generated/server/boardAuth.server';

const GEORGE_ID = '106410322';

/** A customer pressed a pay button on the pay page: log it on Portal Orders and ring George's bell. Not a payment confirmation. */
export const notifyPaymentStarted = createServerFn({ method: 'POST' })
  .validator(z.object({ email: z.string().trim().max(200).optional(), ref: z.string().trim().max(80).optional(), kind: z.string().trim().max(40).optional(), what: z.string().trim().max(200), amount: z.number().min(0).max(1000000), method: z.string().trim().max(40) }))
  .handler(async ({ data }) => withBoardAuth(async () => {
    const what = data.what || 'Unnamed payment';
    const kind = data.kind || 'Payment';
    const board = new PortalOrdersBoard();
    const item = await board.item().create({
      name: `Payment started (${kind}): ${what}`,
      status: 'New Order',
      orderDate: new Date(),
      totalContractValue: data.amount,
      paymentMethod: data.method,
      publication: 'Payment link',
      email: data.email ? { email: data.email, label: data.email } : null,
      startMonth: data.ref ?? null,
      specialInstructions: 'Customer pressed a pay button on the pay page. Check Stripe / Zelle / Venmo / PayPal to confirm the money arrived, then mark this Paid.',
    }).execute();
    await board.item(item.id).notify(GEORGE_ID).create(`${kind}: ${what} is paying $${data.amount} by ${data.method}. Watch for it to arrive.`).execute();
    return { ok: true };
  }));
